import React, { useContext } from 'react';
import { StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { Flex, Box } from '@chakra-ui/react';
import { findT } from '../../_helpers';
import Dropcap from '../../text/Dropcap/Dropcap';
import { LanguageContext } from '../../../providers';
import Separator from '../../structure/Separator/Separator';
import Carousel from '../../media/Carousel/Carousel';
import * as S from './style';
import ConditionalWrapper from '../../structure/ConditionalWrapper/ConditionalWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";
const TeamMembers = _ref => {
  let {
    layout,
    dropcap,
    listImageSectionWidth
  } = _ref;
  const {
    language
  } = useContext(LanguageContext);
  return ___EmotionJSX(StaticQuery, {
    query: query,
    render: data => {
      const teamMembers = data.allDirectusTeamMembers.nodes;
      switch (layout) {
        default:
        case 'list':
          return ___EmotionJSX(Flex, {
            flexWrap: "wrap",
            fluid: true
          }, teamMembers.map((member, i) => {
            const transl = findT(member.translations, language);
            return ___EmotionJSX(React.Fragment, {
              key: member.name
            }, ___EmotionJSX(Box, {
              width: ['100%', `${100 - listImageSectionWidth}%`, `${100 - listImageSectionWidth}%`, `${100 - listImageSectionWidth}%`],
              pr: 50
            }, ___EmotionJSX(ConditionalWrapper, {
              condition: dropcap,
              wrapper: children => ___EmotionJSX(Dropcap, null, children)
            }, ___EmotionJSX("h3", null, member.name)), ___EmotionJSX("div", {
              style: {
                textAlign: 'justify'
              },
              dangerouslySetInnerHTML: {
                __html: transl.description
              }
            })), member.portrait && ___EmotionJSX(Box, {
              width: ['100%', `${listImageSectionWidth}%`, `${listImageSectionWidth}%`, `${listImageSectionWidth}%`]
            }, ___EmotionJSX(Img, {
              fluid: member.portrait.localFile.imageForList.fluid,
              alt: member.name
            })), i + 1 !== teamMembers.length && ___EmotionJSX(Separator, {
              spacing: 20
            }));
          }));
        case 'grid':
          return ___EmotionJSX(S.GridContainer, null, teamMembers.map(member => {
            let transl;
            if (member.translations.length > 0) {
              transl = findT(member.translations, language);
            }
            return ___EmotionJSX(S.GridItem, {
              key: member.name
            }, ___EmotionJSX(Img, {
              fluid: member.portrait.localFile.imageForGrid.fluid,
              alt: member.name
            }), ___EmotionJSX("h3", null, member.name), transl && ___EmotionJSX("div", {
              dangerouslySetInnerHTML: {
                __html: transl.description
              }
            }));
          }));
        case 'slider':
          return ___EmotionJSX(Carousel, null, teamMembers.map(member => ___EmotionJSX("div", {
            key: member.name
          }, ___EmotionJSX(Img, {
            fluid: member.portrait.localFile.imageForSlider.fluid,
            alt: member.name
          }), ___EmotionJSX("p", null, member.name))));
      }
    }
  });
};
TeamMembers.defaultProps = {
  layout: 'list',
  dropcap: true,
  listImageSectionWidth: 50
};
const query = "1682858451";
export default TeamMembers;